import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout/Layout';
import LoginPage from './components/Auth/LoginPage';
import Dashboard from './components/Dashboard/Dashboard';
import DashboardNext from './components/Dashboard/DashboardNext';
import Portfolio from './components/Portfolio/Portfolio';
import Trade from './components/Trade/Trade';
import Profile from './components/Profile/Profile';
import Robot from './components/Robot/Robot';
import Research from './components/Research/Research';
import Reports from './components/Reports/Reports';
import SystemMap from './components/SystemMap/SystemMap';
import CoveredCallWizard from './components/CoveredCall/Wizard';
import ProtectedRoute, { AuthGate } from './components/ProtectedRoute';

/* "/" is not a page: signed in → the desk, otherwise → sign-in. */
const Root: React.FC = () => {
  const { user, loading } = useAuth();
  if (loading) return <AuthGate />;
  return <Navigate to={user ? '/dashboard' : '/login'} replace />;
};

const page = (el: React.ReactElement) => (
  <ProtectedRoute><Layout>{el}</Layout></ProtectedRoute>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<LoginPage />} />

            {/* The redesigned desk IS the dashboard (accepted 9/25).
                The previous one stays at /dashboard-classic for rollback;
                /dashboard-next redirects so bookmarks live. */}
            <Route path="/dashboard" element={page(<DashboardNext />)} />
            <Route path="/dashboard-next" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard-classic" element={page(<Dashboard />)} />
            <Route path="/portfolio" element={page(<Portfolio />)} />
            <Route path="/trade" element={page(<Trade />)} />
            <Route path="/profile" element={page(<Profile />)} />
            <Route path="/research" element={page(<Research />)} />
            <Route path="/robot" element={page(<Robot />)} />
            <Route path="/reports" element={page(<Reports />)} />
            <Route path="/system" element={page(<SystemMap />)} />
            <Route path="/strategy/covered-call/new" element={page(<CoveredCallWizard />)} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
